const { resolve } = require('path');

const locales =
  process.env.NEXT_PUBLIC_CHANNEL_NAME === 'corporate' ? ['default', 'nl', 'en', 'fr'] : ['default', 'nl', 'fr'];

module.exports = {
  i18n: {
    locales,
    defaultLocale: 'default',
    // since the locale detection is causing redirect loops, we disable it for now
    localeDetection: false,
  },
  localePath: resolve('./public/locales'),
};
